import { render, staticRenderFns } from "./Newslinks.vue?vue&type=template&id=ada2ba66&scoped=true&"
import script from "./Newslinks.vue?vue&type=script&lang=js&"
export * from "./Newslinks.vue?vue&type=script&lang=js&"
import style0 from "./Newslinks.vue?vue&type=style&index=0&id=ada2ba66&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada2ba66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VCardText,VCardTitle,VSubheader})
